import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./product_page.scss";
import { allProducts } from "../../../constants/mockData";
import Rating from "../../reusable/Rating/Rating";
import strings from "../../../constants/strings";
import Preloader from "../../reusable/preloader/Preloader";

const ProductPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    // Имитация загрузки из API
    setTimeout(() => {
      const foundProduct = allProducts.find((p) => p.id === parseInt(id));
      setProduct(foundProduct);
      setIsLoading(false);
    }, 500);
  }, [id]);

  if (isLoading) {
    return (
      <div className="product-page product-page--loading">
        <Preloader size={80} />
      </div>
    );
  }

  if (!product) {
    return (
      <div className="product-page product-page--error">
        <h2>Товар не найден</h2>
        <button onClick={() => navigate("/")} className="product-page__back-btn">
          Вернуться на главную
        </button>
      </div>
    );
  }

  return (
    <div className="product-page">
      <div className="product-page__container">
        
        <button onClick={() => navigate(-1)} className="product-page__back-btn">
          &#8592; Назад
        </button>

        <div className="product-page__content">
          <div className="product-page__image-container">
            <img src={product.img} alt={product.title} className="product-page__image" />
          </div>

          <div className="product-page__info">
            <h1 className="product-page__title">{product.title}</h1>
            <div className="product-page__rating">
              <Rating rating={product.rating} />
            </div>
            
            <p className="product-page__description">{product.description}</p>
            
            <div className="product-page__price-block">
              {product.oldPrice && (
                <span className="product-page__price-old">{product.oldPrice} c.-</span>
              )}
              <span className="product-page__price-actual">{product.price} c.</span>
            </div>

            <div className="product-page__actions">
              <button className="product-page__add-btn">{strings.add_to_cart}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPage;
